module.exports = __webpack_public_path__ + "static/media/crab.416f835c.svg";